export default __webpack_public_path__ + "static/mean-duration-chart-small-mobile-4-f8984af95c06e5a97e97802281c30bfb.svg";